// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)


import DynamicSelectController from "./dynamic_select_controller"
application.register("dynamic-select", DynamicSelectController)


import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)


 //const context = require.context("controllers", true, /_controller\.js$/)
//application.load(definitionsFromContext(context))

